import { useNavigate } from 'react-router-dom';
import { SignInForm } from '@medplum/react';
import { Text, Box } from '@mantine/core';
import { AppHeader } from '../components/AppHeader';
import { BackgroundOrbs } from '../components/BackgroundOrbs';
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export function SignIn() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
            <BackgroundOrbs />

            <div className="relative z-10 w-full max-w-md">
                <AppHeader showStatus statusText="System Access // v2.0.4" />

                {/* Glass Panel Form */}
                <Box className="glass-panel p-1 rounded-xl overflow-hidden relative">
                    <div className="scanline absolute top-0 left-0 w-full h-full pointer-events-none opacity-10"></div>
                    <div className="p-6 sm:p-8">
                        <SignInForm
                            clientId={import.meta.env.VITE_MEDPLUM_CLIENT_ID}
                            googleClientId={GOOGLE_CLIENT_ID}
                            onSuccess={() => {
                                navigate('/dashboard');
                            }}
                        >
                        </SignInForm>
                    </div>
                    {/* Tech footer inside card */}
                    <div className="bg-black/40 p-3 border-t border-cyan-500/10 text-center">
                        <Text size="xs" c="dimmed" className="font-mono">SECURE CONNECTION ESTABLISHED</Text>
                    </div>
                </Box>

                {/* Footer Status */}
                <div className="flex items-center justify-center gap-2 mt-8">
                    <div className="h-px w-12 bg-gray-800"></div>
                    <span className="text-xs text-gray-500 uppercase tracking-widest">Authorized Personnel Only</span>
                    <div className="h-px w-12 bg-gray-800"></div>
                </div>
            </div>
        </div>
    );
}
